import { render, staticRenderFns } from "./CompanyMaintenance.vue?vue&type=template&id=0ff1e57e&"
import script from "./CompanyMaintenance.vue?vue&type=script&lang=ts&"
export * from "./CompanyMaintenance.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyMaintenance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports